export interface Type {
  [name: string]: string;
}

export interface Types {
  title: string;
  icon: string;
}

// export const freelance: Type = {
//   'Web Designers': 'icons8-web-50',
//   'Application Designers': 'icons8-app-symbol-50',
//   'Software Developers': 'icons8-developer-50',
//   'Software Engineers': 'icons8-development-skill-50',
//   ' UI Designers': 'icons8-home-screen-50',
//   ' UX Designers': 'icons8-content-50',
//   'Mobile App Developers': 'icons8-developer-mode-50',
//   'Front-End Developers': 'icons8-designer-50',
//   'Data Analysts': 'icons8-analyzing-skill-50',
//   Artists: 'icons8-artist-50',
//   'Graphic Designers': 'icons8-illustrator-50',
//   'Logo Designers': 'icons8-old-vmware-logo-50',
//   Animators: 'icons8-animation-50',
//   'Digital Marketers': 'icons8-promotion-window-50',
//   'Social Media Managers': 'icons8-wechat-50',
//   Advertisers: 'icons8-web-advertising-50',
//   Photographers: 'icons8-camera-on-tripod-50',
//   Writers: 'icons8-quill-with-ink-50',
//   Translators: 'icons8-microsoft-translator-50',
//   Videographers: 'icons8-documentary-50',
//   Editors: 'icons8-photo-editor-50',
//   Producers: 'icons8-video-record-50',
//   'Business Consultant': 'icons8-businessman-50',
//   ' Management Consultants': 'icons8-management-50',
//   'Legal Consultants': 'icons8-law-50',
//   'HR Consultants': 'icons8-user-groups-50',
//   'Event Planners': 'icons8-event-management-50',
//   'Travel Planners': 'icons8-traveler-50'
// };

export const freelance: Type = {
  'Web Designers': 'web',
  'Application Designers': 'app-symbol',
  'Software Developers': 'developer',
  'Software Engineers': 'development-skill',
  'UI Designers': 'home-screen',
  'UX Designers': 'content',
  'Mobile App Developers': 'developer-mode',
  'Front-End Developers': 'designer',
  'Data Analysts': 'analyzing-skill',
  Artists: 'artist',
  'Graphic Designers': 'illustrator',
  'Logo Designers': 'old-vmware-logo',
  Animators: 'animation',
  'Digital Marketers': 'promotion-window',
  'Social Media Managers': 'chat',
  Advertisers: 'web-advertising',
  Photographers: 'camera-on-tripod',
  Writers: 'quill-with-ink',
  Translators: 'microsoft-translator',
  Videographers: 'documentary',
  Editors: 'photo-editor',
  Producers: 'video-record',
  'Business Consultant': 'businessman',
  'Management Consultants': 'management',
  'Legal Consultants': 'law',
  'HR Consultants': 'groups',
  'Event Planners': 'event-management',
  'Travel Planners': 'passenger-with-baggage'
};

// export const ecommerce: Type = {
//   'Business-to-Business Sellers': 'icons8-b2b-50',
//   'Direct-to-Consumer Sellers': 'icons8-reseller-50',
//   'Drop-shippers': 'icons8-drop-shipping-50',
//   'Arbitrage Sellers': 'icons8-sell-stock-50',
//   'Domestic Sellers': 'icons8-market-square-50',
//   'International Sellers': 'icons8-geography-50',
//   Wholesalers: 'icons8-warehouse-50',
//   'Subscription Sellers': 'icons8-renew-50',
//   'Third-Party Marketplaces': 'icons8-online-shop-shopping-bag-50'
// };

export const ecommerce: Type = {
  'Business-to-Business Sellers': 'b2b',
  'Direct-to-Consumer Sellers': 'reseller',
  'Drop-shippers': 'drop-shipping',
  'Arbitrage Sellers': 'sell-stock',
  'Domestic Sellers': 'market-square',
  'International Sellers': 'geography',
  Wholesalers: 'warehouse',
  'Subscription Sellers': 'news',
  'Third-Party Marketplaces': 'online-shop-shopping-bag'
};

// export const smallBusiness: Type = {
//   Wholesalers: 'icons8-warehouse-50',
//   Manufacturers: 'icons8-factory-50',
//   Retailers: 'icons8-shop-50',
//   'Construction Companies': 'icons8-safety-hat-50',
//   Restaurants: 'icons8-restaurant-50',
//   Bars: 'icons8-cocktail-50',
//   Laundromats: 'icons8-washing-machine-50',
//   'Real Estate Agencies': 'icons8-real-estate-agent-50',
//   Lawyers: 'icons8-lawyer-50',
//   'Auto Services': 'icons8-car-service-50',
//   Architects: 'icons8-drawing-compass-50',
//   Dentists: 'icons8-tooth-50',
//   Doctors: 'icons8-stethoscope-50',
//   Hotels: 'icons8-hotel-50',
//   Farmers: 'icons8-farm-50'
// };

export const smallBusiness: Type = {
  Wholesalers: 'warehouse',
  Manufacturers: 'factory',
  Retailers: 'shop',
  'Construction Companies': 'safety-hat',
  Restaurants: 'restaurant',
  Bars: 'cocktail',
  Laundromats: 'washing-machine',
  'Real Estate Agencies': 'real-estate-agent',
  Lawyers: 'lawyer',
  'Auto Services': 'car-service',
  Architects: 'architect',
  Dentists: 'tooth',
  Doctors: 'stethoscope',
  Hotels: 'building',
  Farmers: 'farm'
};

export const startup: Type = {
  SaaS: 'cloud',
  Fintech: 'bitcoin',
  Insurtech: 'security-checked',
  Payments: 'online-payment-with-a-credit-card',
  AI: 'artificial-intelligence',
  'Machine Learning': 'machine-learning',
  'Internet of Things (IOT)': 'internet-of-things',
  'VR/AR': 'virtual-reality',
  Blockchain: 'blockchain',
  Crypto: 'cryptocurrency',
  Cybersecurity: 'cyber-security',
  'App Development': 'smartphone-approve',
  Healthtech: 'heart-with-pulse',
  Edtech: 'calculator',
  'And More': 'more'
};
